import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { IoAlertCircleOutline, IoHelpCircleOutline } from 'react-icons/io5'

const styles = {
  card: `
    p-8
    bg-white
    dark:bg-ox-gray-900
    rounded-2xl
    border
    border-neutral-300
    dark:border-ox-gray-900
    shadow-[0px_16px_24px_0px_rgba(86,86,86,0.08)]
    dark:shadow-[0px_16px_24px_0px_rgba(0,0,0,0.08)]
    font-space
    text-center
    dark:text-neutral-200
  `,
  title: `
    text-2xl
    font-medium
    text-ox-black
    text-center
  `,
  content: `
    mt-2
    text-ox-gray-800
  `,
  icon: `
    text-ox-blue-700
    text-3xl
    inline-block
    mt-2
    dark:text-neutral-200
  `,
}

const getSizeClasses = size => {
  switch (size) {
    case 'small': {
      return 'w-60 text-base'
    }
    case 'large': {
      return 'w-72 text-lg'
    }
    case 'full': {
      return ''
    }
    default: {
      return ''
    }
  }
}

export const Card = ({ title, content, size = 'full', className, children, iconType }) => {
  content = content || children

  const computedClasses = useMemo(() => {
    const sizeClass = getSizeClasses(size)

    return [sizeClass].join(' ')
  }, [size])

  let IconComponent
  switch (iconType) {
    case 'alert':
      IconComponent = IoAlertCircleOutline
      break
    case 'help':
      IconComponent = IoHelpCircleOutline
      break
    default:
      IconComponent = null
  }

  return (
    <div className={`${className || ''} ${styles.card} ${computedClasses}`}>
      <div className={styles.title}>{title}</div>
      {IconComponent && <IconComponent className={styles.icon} />}
      <div className={styles.content}>{content}</div>
    </div>
  )
}

Card.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(['small', 'large', 'full']),
  iconType: PropTypes.oneOf(['alert', 'help']), // Selectable icon options
  className: PropTypes.string,
}
